export const DisplayModes = {
  DATA_VOLUME: 'DATA_VOLUME',
  RECORD_COUNT: 'RECORD_COUNT',
  ERROR_COUNT: 'ERROR_COUNT',
};
